const corrections = [
  { from: /Boro$/, to: 'Borough' },
  { from: 'Greenwich London Borough', to: 'Royal Borough of Greenwich' },
  { from: /^Fo$/, to: 'Public Footpath' },
  { from: /^Br$/, to: 'Bridleway' },
  { from: /^Re$/, to: 'Restricted Bridleway' },
  { from: /^Bo$/, to: 'Byway' },
  { from: /^CONF$/, to: 'CONFIRMED' },
  { from: /^Y$/, to: 'Yes' },
  { from: /^N$/, to: 'No' },
  { from: /^\?$/, to: 'Unknown' },
  { from: 'ï¿½', to: '£' },
  { from: 'Null', to: '' },
  { from: 'null', to: '' },
];
export function Utils() {
  this.layerInfo = {
    lrfh: {
      title: 'HMLR Freehold',
      text: 'HMLR Freehold Boundaries (Including Absolute, Qualified, Possessory, Scheme and Commonhold).',
    },
    lrlh: {
      title: 'HMLR Freehold',
      text: 'HMLR Leasehold Boundaries (Including Absolute, Good, Qualified, Possessory, Scheme and Commonhold).',
    },
    lro: {
      title: 'HMLR Other',
      text:
        'HMLR Freehold Boundaries (Including Absolute Rentcharge. Possessory Rentcharge, Qualified Rentcharge, Caution Against First Registration and Pending).',
    },
    lrtn: {
      title: 'HMLR Title Numbers',
      text: 'HMLR Title Numbers.',
    },
    'radon-layer': {
      title: 'Radon',
      text:
        'The Radon data is separated into 1km grid squares using different colours to determine the level of radon risk.',
    },
    'historic_landfill-layer': {
      title: 'Historic Landfill',
      text:
        'Locations of historic landfill sites that are now closed, meaning there is no Pollution Prevention and Control (PPC) permit or waste management licence currently in force.',
    },
    'permitted_waste-layer': {
      title: 'Permitted Waste/Landfill',
      text:
        'Active landfill sites for waste to be disposed of in the ground.  These site are currently authorised by the Environment Agency.',
    },
    'sssi-layer': {
      title: 'Site of Special Scientific Interest',
      text:
        'The extent of all Site of Special Scientific Interest boundaries within England and Wales.  SSSI are the finest sites for wildlife and natural features.',
    },
    'flood_zones-layer': {
      title: 'Flood Zones',
      text:
        'Flood Zones 2 & 3.  These are widely accepted as standard for flood zones from Rivers & Seas (Fluvial Flooding) in England and Wales.  Flood defences are NOT taken into consideration within this dataset.',
    },
    'historic_flood_outlines-layer': {
      title: 'Historic Flood Outlines',
      text:
        'Historic Flood Outlines shows all Environment Agency records of historic flooding from rivers, the sea, groundwater and surface water.',
    },
    'historic_flood_outlines_wales-layer': {
      title: 'Historic Flood Outlines',
      text:
        'Historic Flood Outlines shows all Environment Agency records of historic flooding from rivers, the sea, groundwater and surface water.',
    },
    'surface_water_flooding-layer': {
      title: 'Surface Water Flooding',
      text: 'Shows the modelled extent of flooding from surface water that could result from a flood.',
    },
    'surface_water_high-layer': {
      title: 'Surface Water Flooding - High',
      text:
        'Shows the modelled extent of flooding from surface water that could result from a flood with a 3.3% (1 in 30) chance of happening in any given year.',
    },
    'surface_water_medium-layer': {
      title: 'Surface Water Flooding - Medium',
      text:
        'Shows the modelled extent of flooding from surface water that could result from a flood with a 1% (1 in 100) chance of happening in any given year.',
    },
    'surface_water_low-layer': {
      title: 'Surface Water Flooding - Low',
      text:
        'Shows the modelled extent of flooding from surface water that could result from a flood with a 0.1% (1 in 1000) chance of happening in any given year.',
    },
    'thames_tideway_tunnel-layer': {
      title: 'Thames Tideway Tunnel',
      text:
        'A 25km tunnel under parts of London and the river Thames that will prevent the tens of millions of tonnes of pollution that currently pollute the River Thames every year.',
    },
    'aonb-layer': {
      title: 'Areas of Outstanding Beauty',
      text:
        'AONB are outstanding landscapes, whose distinctive character and natural beauty are so precious, that they are safeguarded in the national interest.',
    },
    // coldp: {
    //   title: 'City of London - City Development Pipeline',
    //   text:
    //     'Record of all sites of new buildings and refurbishments over 1000 sq. m in the development pipeline at the time of the last development survey (end of March/September).',
    // },
    // colcdp: {
    //   title: 'City of London - City Development Pipeline',
    //   text:
    //     'Record of all sites of new buildings and refurbishments over 1000 sq. m in the development pipeline at the time of the last development survey (end of March/September).',
    // },
    'coltpo-layer': {
      title: 'City of London - Tree Preservation Orders',
      text:
        "Tree Preservation Orders (TPO's) give legal protection against a tree being cut down, topped, lopped, uprooted, wilfully damaged or wilfully destroyed.",
    },
    'colph-layer': {
      title: 'City of London - Privately Maintained Highways',
      text: 'Privately Maintainable Highway for the City of London.',
    },
    'colhe-layer': {
      title: 'City of London - Highways Extent',
      text: 'Extent of the Highways Maintainable at Public Expense for the City of London.',
    },
    'chesbs-layer': {
      title: 'Cheshire East - Brownfield Register',
      text:
        'Brownfield Land Register Regulations (2017) require local planning authorities to prepare, maintain and publish registers of previously developed (brownfield) land, consider to be appropriate for residential development.',
    },
    'cheslp-layer': {
      title: 'Cheshire East - Local Plan Strategy',
      text:
        'The LPS sets out the overall vision and planning strategy for development in the borough and contains planning policies, strategic sites and locations.',
    },
    'chesm-layer': {
      title: 'Cheshire East - Minerals',
      text:
        'The Cheshire Replacement Minerals Local Plan, adopted in 1999, provides planning advice on where mineral development can take place.',
    },
    'chessc-layer': {
      title: 'Cheshire East - Smoke Control Area',
      text:
        'Smoke Control Areas are declared by local authorities in order to control the types of fuel that can be burnt on heating appliances in buildings, to prevent air pollution.',
    },
    'chestpo-layer': {
      title: 'Cheshire East - Tree Preservation Orders',
      text:
        "Tree Preservation Orders (TPO's) give legal protection against a tree being cut down, topped, lopped, uprooted, wilfully damaged or wilfully destroyed.",
    },
    'ne_crow_access_layer-layer': {
      title: 'Common Land & Greens',
      text:
        'Areas of Common Land & Greens are mapped under the Countryside and Rights of Way Act 2000 (CRoW Access Layer). Includes Open Country and Registered Common Land.',
    },
    'ne_crow_section_15_land-layer': {
      title: 'Common Land & Greens (Sec.15)',
      text: 'Shows land subject to pre-existing public access rights on CRoW access land.',
    },
    'conservation-layer': {
      title: 'Conservation Areas',
      text:
        'Conservation areas exist to manage and protect the special architectural and historic interest of a place, the features that make it unique.',
    },
    'green_belt-layer': {
      title: 'Green Belt',
      text: 'Green Belt is an area of open land around cities and towns, on which building is restricted.',
    },
    'listed_buildings-layer': {
      title: 'Listed Buildings',
      text:
        'Listed buildings have special architectural and historic interest, and also brings it under the consideration of the planning system, so that it can be protected for future generations.',
    },
    'he_parksandgardens-layer': {
      title: 'Parks & Gardens',
      text:
        'Historic Parks and Gardens are of special historic interest in England and include gardens, grounds and other planned open spaces, such as town squares.',
    },
    'prow-layer': {
      title: 'Public Rights of Way',
      text: 'All public rights of way where coverage is available (approx. 95% of England & Wales).',
    },
    'he_scheduled_monuments-layer': {
      title: 'Scheduled Monuments',
      text: 'A scheduled monument is an historic building or site considered to be of national importance.',
    },
    'boundaries-layer': {
      title: 'Boundaries',
      text:
        'This layer will tell you which Local Authority, County & Country you are in wherever you click on the map.  The boundary polygons are edged in bright pink.',
    },
    'abandoned_mines-layer': {
      title: 'Abandoned Mines Catalogue',
      text:
        'A combination dataset of coal and other mineral abandonment plans, covering both surface and deep mining operations.  It depict areas of coal and other mineral extraction and the point of entry into these workings.',
    },
    'dev_high-layer': {
      title: 'Development High Risk Area',
      text:
        'A combination of features included in this composite area includes mine entries; shallow coal workings (recorded and probable); recorded coal mining related hazards; recorded mine gas sites; fissures and breaklines and previous surface mining sites. ',
    },
    'mine_entry-layer': {
      title: 'Mine Entries',
      text: 'Mine entries indicate the entrance into a mine working, for which there are two types: shafts and adits.',
    },
    'cheshire_brine-layer': {
      title: 'Cheshire Brine',
      text:
        'A single Compensation District covering the areas of Cheshire where there is the potential for subsidence resulting from the pumping of brine.',
    },
    'planning_authorities-layer': {
      title: 'Planning Applications',
      text:
        "Planning application history, include all planning applications that are available on the LA's website, dating back 10 years or more.",
    },
    'crossrail-layer': {
      title: 'Crossrail',
      text:
        'Also known as The Elizabeth Line the data shows the presence and positioning of Crossrail 1 route & 2, plus station locations.',
    },
    'highways-layer': {
      title: 'Highways',
      text:
        'All roads in England & Wales with data including Maintenance Responsibility, Road Name, Local Authority Responsible, Restrictions (Height, Weight, Width), Bridges etc.',
    },
    'hs2-layer': {
      title: 'HS2',
      text: 'The proposed route of the HS2 Phase 1 & 2.',
    },
    'mailrail-layer': {
      title: 'Mail Rail',
      text:
        'The Post Office Railway, known as Mail Rail was built  to move mail between sorting offices in Paddington and Whitechapel. It operated from 1927 until 2003 but is now a museum.',
    },
    'dlr-layer': {
      title: 'Docklands Light Railway (DLR)',
      text: 'The DLR is an automated light metro system to serve the redeveloped Docklands area of East London.',
    },
    'underground-layer': {
      title: 'London Underground',
      text:
        'London Underground displayed as a correct geographical representation of the London Underground tube network.',
    },
    'special_areas_of_conservation_england-layer': {
      title: 'Special Areas of Conservation',
      text:
        'Special Areas of Conservation (SACs) are strictly protected sites designated under the EC Habitats Directive.',
    },
    'special_protection_areas_wales-layer': {
      title: 'Special Areas of Conservation',
      text:
        'Special Areas of Conservation (SACs) are strictly protected sites designated under the EC Habitats Directive.',
    },
    'special_areas_of_conservation_wales-layer': {
      title: 'Special Areas of Conservation',
      text:
        'Special Areas of Conservation (SACs) are strictly protected sites designated under the EC Habitats Directive.',
    },
    'special_protection_areas_england-layer': {
      title: 'Special Protection Areas',
      text:
        'Special Protection Areas (SPAs) are strictly protected sites classified in accordance with Article 4 of the EC Birds Directive, which came into force in April 1979.',
    },
    'national_nature_reserves_england-layer': {
      title: 'National Nature Reserves',
      text:
        'A National Nature Reserve is the land declared under the National Parks and Access to the Countryside Act 1949 or Wildlife and Countryside Act (1981) as amended.',
    },
    'local_nature_reserves_england-layer': {
      title: 'Local Nature Reserves',
      text:
        'Local Nature Reserves are a statutory designated places with wildlife or geological features that are of special interest locally. They range from windswept coastal headlands to ancient woodlands and flower-rich meadows.',
    },
    'local_nature_reserves_wales-layer': {
      title: 'Local Nature Reserves',
      text:
        'Local Nature Reserves are a statutory designated places with wildlife or geological features that are of special interest locally. They range from windswept coastal headlands to ancient woodlands and flower-rich meadows.',
    },
    'england_highways-layer': {
      title: 'Highways England',
      text:
        'This dataset represents the land Highways England manages as highway. This dataset is indicative, full ownership details can be found through the Land Registry.',
    },
    'designated_protected_areas-layer': {
      title: 'Designated Protected Areas',
      text:
        'Parish polygons with their associated protection status for grant-funded shared ownership and provision of affordable housing.',
    },
    'n_norfolk_section_106-layer': {
      title: 'North Norfolk Section 106',
      text:
        'A legal agreement between an applicant seeking planning permission and the local planning authority, which is used to mitigate the impact of your new home on the local community and infrastructure.',
    },
    'n_norfolk_article_4-layer': {
      title: 'North Norfolk Article 4',
      text:
        'An article 4 direction restricts the scope of permitted development rights either in relation to a particular area or site, or a particular type of development anywhere in the authority’s area.',
    },
    'n_norfolk_cpo-layer': {
      title: 'North Norfolk Compulosry Purchase Orders',
      text:
        'A legal function in the United Kingdom and Ireland that allows certain bodies to obtain land or property without the consent of the owner.',
    },
    'n_norfolk_llb-layer': {
      title: 'North Norfolk Locally Listed Buildings',
      text:
        'There may be many buildings and sites in a local planning authority’s area that make a positive contribution to its local character and sense of place because of their heritage value.',
    },
    'n_norfolk_prop_retail-layer': {
      title: 'North Norfolk Proposed Retail',
      text: 'Land allocated for Car Parking in the Site Specific Allocations Development Plan.',
    },
    'n_norfolk_tpo-layer': {
      title: 'North Norfolk Tree Preservation',
      text:
        'Tree Preservation Orders (TPOs) for the Cheshire East Local Authority.  The Order gives legal protection against a tree being cut down, topped, lopped, uprooted, wilfully damaged or wilfully destroyed.',
    },
    'gla_article_4-layer': {
      title: 'GLA Article 4',
      text:
        'An article 4 direction restricts the scope of permitted development rights either in relation to a particular area or site, or a particular type of development anywhere in the authority’s area.',
    },
    'gla_brownfield-layer': {
      title: 'GLA Brownfield Sites',
      text:
        'Brownfield Land Register Regulations (2017) require local planning authorities to prepare, maintain and publish registers of previously developed (brownfield) land, consider to be appropriate for residential development.',
    },
    'gla_conservation_areas-layer': {
      title: 'GLA Conservation Areas',
      text:
        'Conservation areas exist to manage and protect the special architectural and historic interest of a place, the features that make it unique.',
    },
    'gla_designated_open-layer': {
      title: 'GLA Designated Open Spaces',
      text:
        'Designated Open Space includes lands designated as Green Belt, Metropolitan Open Land (MOL) and other public open spaces. These lands receive strong protected against development and are a vital component of London’s infrastructure.',
    },
    'gla_housing_zones-layer': {
      title: 'GLA Housing Zones',
      text:
        'Housing zones are areas funded by the Mayor and government to attract developers and relevant partners to build new homes.',
    },
    'gla_protected_vistas-layer': {
      title: 'GLA Protected Vistas',
      text:
        'The Protected Vistas seeks to protect the significant views which help to define London, including the panoramas, linear views and townscape views in this layer.',
    },
    'gla_site_allocations-layer': {
      title: 'GLA Site Allocations',
      text:
        'A Site Allocation means that the site is allocation for a particular type of development or use, such as housing, employment and leisure, within a development plan.',
    },
    'gla_sinc-layer': {
      title: 'GLA SINC',
      text:
        'Sites of Importance for Nature Conservation (SINCs) are sites that are of particular importance to wildlife and biodiversity. SINCs receive a high level of protection from development within the planning system.',
    },
    'gla_strategic_housing-layer': {
      title: 'GLA Strategic Housing',
      text:
        'A Strategic Housing Land Availability Assessment (SHLAA) is a technical exercise to determine the quantity and suitability of land potentially available for housing development.',
    },
    'england_coastal_path-layer': {
      title: 'Coastal Paths',
      text: 'All approved stretches of Coast Paths in England & Wales.',
    },
    'wales_coastal_path-layer': {
      title: 'Coastal Paths',
      text: 'All approved stretches of Coast Paths in England & Wales.',
    },
    'cil-layer': {
      title: 'Community Infrastructure Levy (CIL)',
      text:
        'The Community Infrastructure Levy (CIL) is a charge which can be levied by local authorities to help them deliver the infrastructure needed to support new developments.',
    },
    'enterprise_zones-layer': {
      title: 'Enterprise Zones',
      text: 'Enterprise Zones are designated areas across England that provide tax breaks and Government support.',
    },
    'gla_bid-layer': {
      title: 'GLA Business Improvement Districts',
      text:
        'A Business Improvement District is a defined area in which a levy is charged on all business rate payers in addition to the business rates bill. This levy is used to develop projects which will benefit businesses in the local area.',
    },
    'stockport_article_4_1-layer': {
      title: 'Stockport Article 4.1',
      text: `Article 4 Directions allow the Council to ensure that conservation areas are suitably protected from extensive development by removing certain 'permitted development' rights within conservation areas.`,
    },
    'stockport_article_4_2-layer': {
      title: 'Stockport Article 4.2',
      text: `Article 4 Directions allow the Council to ensure that conservation areas are suitably protected from extensive development by removing certain 'permitted development' rights within conservation areas.`,
    },
    'stockport_compulsory_purchase_orders-layer': {
      title: 'Stockport CPOs',
      text: `A legal function in the United Kingdom and Ireland that allows certain bodies to obtain land or property without the consent of the owner.`,
    },
    'stockport_conservation_areas-layer': {
      title: 'Stockport Conservation Areas',
      text:
        'Conservation areas exist to manage and protect the special architectural and historic interest of a place, the features that make it unique.',
    },
    'stockport_highways_schemes-layer': {
      title: 'Stockport Highways Extent',
      text: 'Extent of the Highways Maintainable at Public Expense for Stockport Metropolitan Borough Council.',
    },
    'stockport_section106_landcharge-layer': {
      title: 'Stockport Section 106',
      text:
        'A legal agreement between an applicant seeking planning permission and the local planning authority, which is used to mitigate the impact of your new home on the local community and infrastructure.',
    },
    'stockport_tpo_combined-layer': {
      title: 'Stockport TPOs',
      text:
        'Tree Preservation Orders (TPOs) give legal protection against a tree being cut down, topped, lopped, uprooted, wilfully damaged or wilfully destroyed.',
    },
    'stockport_smoke_control_area-layer': {
      title: 'Stockport Smoke Control Areas',
      text:
        'Smoke Control Areas are declared by local authorities in order to control the types of fuel that can be burnt on heating appliances in buildings, to prevent air pollution.',
    },
    'chesdm-layer': {
      title: 'Chester & Cheshire West - Live Planning Applications',
      text: `Planning application history, include all planning applications that are available on the LA's website, dating back 10 years or more.`,
    },
    'chesaoap-layer': {
      title: 'Chester & Cheshire West - Areas of Archaeological Potential',
      text:
        'Areas of Archaeological Potential are areas within the historic cores of towns and villages, where it is probable that archaeological remains will be encountered.',
    },
    'chesacz-layer': {
      title: 'Chester & Cheshire West - Archaeological Character Zones',
      text: `Chester’s Archaeological Character Zones are areas defined by their predominant archaeological character.  Each zone has its own Statement which includes a summary of key characteristics.`,
    },
    'cheslca-layer': {
      title: 'Chester & Cheshire West - Conservation Areas',
      text:
        'Conservation areas exist to manage and protect the special architectural and historic interest of a place, the features that make it unique.',
    },
    'cheslb-layer': {
      title: 'Chester & Cheshire West - Listed Buildings',
      text:
        'Listed buildings have special architectural and historic interest, and also brings it under the consideration of the planning system, so that it can be protected for future generations.',
    },
    'chesllb-layer': {
      title: 'Chester & Cheshire West - Locally Listed Buildings',
      text:
        'Distinct from listed buildings, locally listed buildings have been identified as having local interest and importance. The identification as a locally important building comes with no additional restrictions.',
    },
    'cheswtpo-layer': {
      title: 'Chester & Cheshire West - Tree Preservation Orders',
      text:
        'Tree Preservation Orders (TPOs) give legal protection against a tree being cut down, topped, lopped, uprooted, wilfully damaged or wilfully destroyed.',
    },
    'lineSearch-layer': {
      title: 'LineSearchBeforeUDig',
      text: 'Identifies any known utility assets for all LineSearchBeforeUDig members.',
    },
  };
  this.logoData = {
    linesearch: {
      title: 'LineSearch Before U Dig',
      logo: 'linesearch.png',
      noOGL: true,
    },
    linesearchNon: {
      title: 'LineSearch Before U Dig',
      logo: 'linesearch.png',
      noOGL: true,
    },
    linesearchUnaffected: {
      title: 'LineSearch Before U Dig',
      logo: 'linesearch.png',
      noOGL: true,
    },
    article_4_1: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    conservation_area: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    adopted_highway_bng: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    article_4_2: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    compulsory_purchase_orders: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    tpo_merged: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    section106_landcharge: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    smoke_control_area: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    pt4_cpo: {
      title: 'Stockport Metropolitan Borough Council',
      logo: 'stockport.png',
    },
    vw_designated_protected_areas: {
      title: 'Homes England',
      logo: 'homesEngland.png',
    },
    enterprise_zones: {
      title: 'Data.gov.uk',
      logo: 'data-gov-uk.png',
      height: '36px',
    },
    vw_la_cil_data: {
      title: 'Data.gov.uk',
      logo: 'data-gov-uk.png',
      height: '36px',
    },
    vw_la_cil_data_dev: {
      title: 'Data.gov.uk',
      logo: 'data-gov-uk.png',
      height: '36px',
    },
    vw_cheshire_brine_area: {
      title: 'Cheshire Brine Subsidence Compensation Board',
      logo: 'cheshire_brine.png',
    },
    AM_S_LocalPlanMineralsPeakDistrictNationalPark_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_LocalPlanMineralsExistingQuarry_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_LocalPlanMineralsAreaofPreferredExtensionforSandandGravelExtraction_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_LocalPlanMineralsAreaOfSearchforSandandGravel_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_LocalPlanMineralsAreaOfPreferredExtensiontoExistingSilicaSandQuarry_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_LocalPlanMineralsAreaOfPreferredExtensiontoExistingSaltMine_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_LocalPlanMineralsAreaOfPreferredExtensiontoControlledBrinefield_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_BrownfieldRegisterSites_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_CheshireEastLocalPlanStrategy_POLY_2010to2030: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    AM_S_Smokecon_POLY_CURRENT: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    LU_S_TPO_PNT_current: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    LU_S_TPO_POLY_current: {
      title: 'Cheshire East Council',
      logo: 'cheshire.png',
    },
    vw_os_boundaryline_district_borough_unitary_mhw_clip: {
      title: 'Ordnance Survey / Office for National Statistics',
      logo: 'os-ons.jpg',
    },
    vw_bgs_radon_gb_atlas: {
      title: 'Data source: British Geological Survey',
      logo: 'bgsLogo.jpg',
    },
    vw_ne_sssi_england: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    vw_ne_sssi_wales: {
      title: 'Natural England',
      logo: 'NRW.jpg',
      titleWales: 'Natural Resources Wales',
      logoWales: 'NRW.jpg',
    },
    planningapplications: {
      title: 'Landinsight',
      logo: 'landinsight.svg',
      noOGL: true,
      height: '36px',
    },
    vw_historic_landfill_sites: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
    },
    Local_Nature_Reserves_England: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    National_Nature_Reserves_England: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    Special_Areas_of_Conservation_England: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    Special_Protection_Areas_England: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    'surface-water-3-3': {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
    },
    'surface-water-1': {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
    },
    'surface-water-0-1': {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
    },
    Recorded_Flood_Outlines: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
    },
    NRW_HISTORIC_FLOODMAP: {
      title: 'Natural Resources Wales',
      logo: 'NRW.jpg',
    },
    NRW_LNR: {
      title: 'Natural Resources Wales',
      logo: 'NRW.jpg',
    },
    NRW_NNR: {
      title: 'Natural Resources Wales',
      logo: 'NRW.jpg',
    },
    NRW_SAC: {
      title: 'Natural Resources Wales',
      logo: 'NRW.jpg',
    },
    NRW_SPA: {
      title: 'Natural Resources Wales',
      logo: 'NRW.jpg',
    },

    vw_authorised_landfill_sites: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
    },
    rofrs_ea_v201905: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
      titleWales: 'Natural Resources Wales',
      logoWales: 'NRW.jpg',
    },
    vw_rofrs: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
      titleWales: 'Natural Resources Wales',
      logoWales: 'NRW.jpg',
    },
    vw_rofrs_157: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
      titleWales: 'Natural Resources Wales',
      logoWales: 'NRW.jpg',
    },
    ea_flood: {
      title: 'Environment Agency',
      logo: 'Environment Agency.png',
      titleWales: 'Natural Resources Wales',
      logoWales: 'NRW.jpg',
    },
    listed_buildings_032020: {
      title: 'Historic England',
      logo: 'Historic England3.png',
      titleWales: 'Cadw Wales',
      logoWales: 'cadw-logo.jpg',
    },
    vw_listed_buildings: {
      title: 'Historic England',
      logo: 'Historic England3.png',
      titleWales: 'Cadw Wales',
      logoWales: 'cadw-logo.jpg',
    },
    listed_buildings_2019: {
      title: 'Historic England',
      logo: 'Historic England3.png',
      titleWales: 'Cadw Wales',
      logoWales: 'cadw-logo.jpg',
    },
    vw_conservation_areas: {
      title: 'Historic England',
      logo: 'Historic England3.png',
      titleWales: 'Cadw Wales',
      logoWales: 'cadw-logo.jpg',
    },
    vw_parksandgardens: {
      title: 'Historic England',
      logo: 'Historic England3.png',
    },
    vw_scheduled_monuments: {
      title: 'Historic England',
      logo: 'Historic England3.png',
    },
    vw_scheduled_monuments_dev: {
      title: 'Historic England',
      logo: 'Historic England3.png',
    },
    he_scheduledmonuments_26_01_2018: {
      title: 'Historic England',
      logo: 'Historic England3.png',
    },
    he_scheduled_monuments_032020: {
      title: 'Historic England',
      logo: 'Historic England3.png',
    },
    vw_aonb: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
      titleWales: 'Natural Resources Wales',
      logoWales: 'NRW.jpg',
    },
    vw_crow_access: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    vw_crow_section_15_land: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    vw_greenbelt: {
      title: 'Data.gov.uk',
      logo: 'data-gov-uk.png',
      height: '36px',
    },
    greenbelt_2018_19: {
      title: 'Data.gov.uk',
      logo: 'data-gov-uk.png',
      height: '36px',
    },
    vw_prow_find: {
      title: 'Data.gov.uk',
      logo: 'data-gov-uk.png',
      height: '36px',
    },
    vw_england_highways: {
      title: 'Highways England',
      logo: 'highways_england.png',
    },
    highways: {
      title: 'Ordnance Survey',
      logo: 'os-logo-2.png',
      noOGL: true,
    },
    vw_crossrail_route: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    crossrail: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    vw_crossrail_station: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    tb_crossrail: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    tb_crossrail_stations: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    crossrail_2: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    crossrail_2_stations: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    crossrail_2_2015: {
      title: 'Crossrail',
      logo: 'crossrail-logo.png',
    },
    vw_hs2_phase1: {
      title: 'HS2',
      logo: 'HS2_logo.jpg',
    },
    vw_hs2_phase2: {
      title: 'HS2',
      logo: 'HS2_logo.jpg',
    },
    vw_dlr: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    underground_lines: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    underground_routes: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    vw_underground_stations: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    vw_underground_lines: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    vw_underground_routes: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    tb_underground_routes_old: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    underground_stations: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    vw_mail_rail_route: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    vw_mail_rail_stations: {
      title: 'Transport for London',
      logo: 'TfL-logo.png',
    },
    vw_thames_tideway_tunnel: {
      title: 'Tideway (Bazalgette Tunnel Limited)',
      logo: 'tideway.png',
    },
    Abandoned: {
      title: 'The Coal Authority',
      logo: 'coal.png',
    },
    Mine: {
      title: 'The Coal Authority',
      logo: 'coal.png',
    },
    Development: {
      title: 'The Coal Authority',
      logo: 'coal.png',
    },
    '36': {
      title: 'City of London',
      logo: 'col.png',
    },
    '34': {
      title: 'City of London',
      logo: 'col.png',
    },
    '74': {
      title: 'City of London',
      logo: 'col.png',
    },
    '28': {
      title: 'City of London',
      logo: 'col.png',
    },
    '66': {
      title: 'City of London',
      logo: 'col.png',
    },
    n_norfolk_tpo: {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    '3': {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    '4': {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    '5': {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    '8': {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    '22': {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    '27': {
      title: 'North Norfolk District Council',
      logo: 'north_norfolk-logo.png',
    },
    gla_conservation_areas: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_bid: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_brownfield: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_article_4: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_designated_open: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_housing_zones: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_strategic_housing: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_sinc: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_site_allocations: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    gla_protected_vistas: {
      title: 'Greater London Authority',
      logo: 'gla-logo.png',
    },
    England_Coast_Path_Route: {
      title: 'Natural England',
      logo: 'Natural England.jpg',
    },
    NRW_WALES_COASTAL_PATH: {
      title: 'Natural Resources Wales',
      logo: 'NRW.jpg',
    },
    PS_SD_HBSMRAreasOfArchaeologicalPotential_POLY_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    LU_SD_HBSMRArchaeologicalCharacterZones_POLY_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    PS_SD_HBSMRConservationAreas_POLY_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    AM_S_IDOXDevelopmentManagement_POLY_CURRENT_View: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    PS_SD_HBSMRListedBuildings_POLY_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    PS_SD_HBSMRLocallyListedBuildings_POLY_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    AM_S_IDOXTreePreservation_POLY_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
    AM_S_IDOXTreePreservation_POINT_CURRENT: {
      title: 'Cheshire West and Chester',
      logo: 'cwac-logo.png',
    },
  };
  this.radondata = {
    '1': {
      affected: 'No',
      action: '0-1%',
      prob:
        'The property is in a Lower probability radon area (less than 1% of homes are estimated to be at or above the Action Level)',
      prot: 'None',
      req: 'None',
    },
    '2': {
      affected: 'Yes',
      action: '1-3%',
      prob:
        'The property is in an Intermediate probability radon area (1 to 3% of homes are estimated to be at or above the Action Level)',
      prot: 'None',
      req: 'None',
    },
    '3': {
      affected: 'Yes',
      action: '3-5%',
      prob:
        'The property is an Intermediate probability radon area (3 to 5% of homes are estimated to be at or above the Action Level)',
      prot: 'Basic',
      req: 'Sealed anti-radon membrane installed under the ground floor',
    },
    '4': {
      affected: 'Yes',
      action: '5-10%',
      prob:
        'The property is in an Intermediate probability radon area (5 to 10% of homes are estimated to be at or above the Action Level)',
      prot: 'Basic',
      req: 'Sealed anti-radon membrane installed under the ground floor',
    },
    '5': {
      affected: 'Yes',
      action: '10-30%',
      prob:
        'The property is in a Higher probability radon area (10 to 30% of homes are estimated to be at or above the Action Level)',
      prot: 'Full',
      req: 'Basic measures plus a Radon sump &/or electric pump',
    },
    '6': {
      affected: 'Yes',
      action: '30-100%',
      prob:
        'The property is in a Higher probability radon area (more than 30% of homes are estimated to be at or above the Action Level)',
      prot: 'Basic',
      req: 'Basic measures plus a Radon sump &/or electric pump',
    },
  };
  this.ctrtkey = false;
  this.shiftkey = false;
  this.country = 'England';
  this.altkey = false;
  this.dictionary = {
    DG: 'Dealing of whole.',
    DP: 'Dealing of part  (Old Title).',
    NT: 'New Title being a collective name of application services being DFL, FR and TP.',
    OLAs: 'Outline Application (Please note that OLAs are due to be abolished in 2017).',
    'OS(P)': 'Official Search with priority of Part.',
    'OS(W)': 'Official Search with priority of Whole.',
    DFL:
      'An application for the registration of a new lease granted by the proprietor of registered land (landlord’s title).',
    'DFL(OT)': 'An application against the landlord’s title when a registration of a new lease is lodged.',
    DLG: 'An application in respect of the whole of a registered title.',
    FR: 'An application to register land for the first time.',
    OLA:
      'Outline application. An application which reserves a “time slot” on the Day list (the reserved period) for a dealing with the whole of the land in a registered title which cannot be protected by an official search r.54, LRR 2003 (Please note that OLAs are due to be abolished in 2017).',
    'OLA(S)':
      'An OLA that has been converted into a Dealing type application. (Please note that OLAs are due to be abolished in 2017).',
    OS1:
      'An official search of whole with priority. Used to protect a transaction i.e. purchase for value, lease or charge of land against a registered title. The priority in effect freezes the registered title for 30 business days to allow the transaction to be completed and lodged at Land Registry.',
    OS2:
      'An official search of part with priority. Used to protect a transaction i.e. purchase for value, lease or charge of land against part of a registered title. The priority in effect freezes the registered title for 30 business days to allow the transaction to be completed and lodged at Land Registry.',
    'OS3(P)': 'An official search of part without priority.',
    'OS3(W)': 'An official search of whole without priority.',
    TP:
      'An application to register a Transfer of Part of a registered title. The land transferred is removed from one title, referred to as the old title (OT) and registered under a new and separate title number (New Title).',
    'TP(OT)': 'An application against the old title when a TP is lodged as referred to above.',
    ACS: 'Amendment of the commonhold community statement / Mems & Arts.',
    BKN: 'Bankruptcy.',
    BKY: 'Inhibition.',
    CAN: 'Cancellation of Notice.',
    CBK: 'Cancellation of Bankruptcy Restriction.',
    CCF: 'Freehold conversion to commonhold.',
    CCL: 'Leasehold conversion to commonhold.',
    CCS: 'New commonhold development.',
    CHB: 'Cancellation of Inhibition.',
    CRX: 'Amendment (post registration).',
    CTB: 'Cease to be commonhold in the transitional period.',
    CTD: 'Commonhold transitional dealing (end of transitional period).',
    CTT: 'Cancellation of notice of death duties, capital transfer tax or inheritance tax.',
    DCX: 'Departmental amendment.',
    DIS: 'Discharge of Charge.',
    DIT: 'Data Integrity Team.',
    DPA: 'Departmental.',
    EDA: 'Electronic Discharge Automatic.',
    EDM: 'Electronic Discharge Manual.',
    END: 'Electronic Notification of Discharge.',
    NDP: 'Bulk Application',
    NDA: 'Bulk Application',
    RCU: 'Removal of a commonhold unit.',
    SCA: 'Registration of a successor commonhold association.',
    TRM: 'Termination of commonhold.',
    WCT: 'Warning-off or withdrawal of caution.',
    WND: 'Withdrawal of Notice of (intended) deposit.',
  };
  this.definitions = {
    vw_prow_find: {
      type: {
        fo: 'Footpath',
        br: 'Bridleway',
        re: 'Restricted Byways',
        bo: 'Byways Open to All',
      },
    },
    prow_full_find: {
      type: {
        fo: 'Footpath',
        br: 'Bridleway',
        re: 'Restricted Byways',
        bo: 'Byways Open to All',
      },
    },
    rofrs_ea_v201905: {
      prob_4band: {
        high: 'High: each year, there is a chance of flooding of greater than 1 in 30 (3.3%)',
        medium: 'Medium: each year, there is a chance of flooding of between 1 in 30 (3.3%) and 1 in 100 (1%).',
        low: 'Low: each year, there is a chance of flooding of between 1 in 100 (1%) and 1 in 1000 (0.1%).',
        'very low': 'Very Low: each year, there is a chance of flooding of less than 1 in 1000 (0.1%).',
      },
      suitabilit: {
        'county to town':
          'County to Town: Unlikely to be reliable for a local area (suitable for identifying approximate extents, shallower and deeper areas).',
        'national to county':
          'National to County: Very unlikely to be reliable for a local area (Suitable for identifying areas with a natural vulnerability to flood first, deepest or most frequently).',
        'town to street':
          'Town to Street: Unlikely to be reliable for identifying individual properties at risk (and so the information is suitable for areas of land, not individual properties).',
        'street to parcels of land':
          'Street to Parcels of Land: Likely to be reliable for identifying individual properties at risk (though not whether they flood internally, so the information is suitable for areas of land, not individual properties).',
        'property (inc. internal)':
          'Property (inc. Internal): Likely to be very reliable at identifying individual properties at risk, including depths of flooding internally (this provides a genuine property level assessment).',
      },
    },
    vw_rofrs_157: {
      prob_4band: {
        high: 'High: each year, there is a chance of flooding of greater than 1 in 30 (3.3%)',
        medium: 'Medium: each year, there is a chance of flooding of between 1 in 30 (3.3%) and 1 in 100 (1%).',
        low: 'Low: each year, there is a chance of flooding of between 1 in 100 (1%) and 1 in 1000 (0.1%).',
        'very low': 'Very Low: each year, there is a chance of flooding of less than 1 in 1000 (0.1%).',
      },
      suitabilit: {
        'county to town':
          'County to Town: Unlikely to be reliable for a local area (suitable for identifying approximate extents, shallower and deeper areas).',
        'national to county':
          'National to County: Very unlikely to be reliable for a local area (Suitable for identifying areas with a natural vulnerability to flood first, deepest or most frequently).',
        'town to street':
          'Town to Street: Unlikely to be reliable for identifying individual properties at risk (and so the information is suitable for areas of land, not individual properties).',
        'street to parcels of land':
          'Street to Parcels of Land: Likely to be reliable for identifying individual properties at risk (though not whether they flood internally, so the information is suitable for areas of land, not individual properties).',
        'property (inc. internal)':
          'Property (inc. Internal): Likely to be very reliable at identifying individual properties at risk, including depths of flooding internally (this provides a genuine property level assessment).',
      },
    },
    vw_rofrs: {
      prob_4band: {
        high: 'High: each year, there is a chance of flooding of greater than 1 in 30 (3.3%)',
        medium: 'Medium: each year, there is a chance of flooding of between 1 in 30 (3.3%) and 1 in 100 (1%).',
        low: 'Low: each year, there is a chance of flooding of between 1 in 100 (1%) and 1 in 1000 (0.1%).',
        'very low': 'Very Low: each year, there is a chance of flooding of less than 1 in 1000 (0.1%).',
      },
      suitabilit: {
        'county to town':
          'County to Town: Unlikely to be reliable for a local area (suitable for identifying approximate extents, shallower and deeper areas).',
        'national to county':
          'National to County: Very unlikely to be reliable for a local area (Suitable for identifying areas with a natural vulnerability to flood first, deepest or most frequently).',
        'town to street':
          'Town to Street: Unlikely to be reliable for identifying individual properties at risk (and so the information is suitable for areas of land, not individual properties).',
        'street to parcels of land':
          'Street to Parcels of Land: Likely to be reliable for identifying individual properties at risk (though not whether they flood internally, so the information is suitable for areas of land, not individual properties).',
        'property (inc. internal)':
          'Property (inc. Internal): Likely to be very reliable at identifying individual properties at risk, including depths of flooding internally (this provides a genuine property level assessment).',
      },
    },
    ea_flood: {
      prob_4band: {
        high: 'High: each year, there is a chance of flooding of greater than 1 in 30 (3.3%)',
        medium: 'Medium: each year, there is a chance of flooding of between 1 in 30 (3.3%) and 1 in 100 (1%).',
        low: 'Low: each year, there is a chance of flooding of between 1 in 100 (1%) and 1 in 1000 (0.1%).',
        'very low': 'Very Low: each year, there is a chance of flooding of less than 1 in 1000 (0.1%).',
      },
      suitabilit: {
        'county to town':
          'County to Town: Unlikely to be reliable for a local area (suitable for identifying approximate extents, shallower and deeper areas).',
        'national to county':
          'National to County: Very unlikely to be reliable for a local area (Suitable for identifying areas with a natural vulnerability to flood first, deepest or most frequently).',
        'town to street':
          'Town to Street: Unlikely to be reliable for identifying individual properties at risk (and so the information is suitable for areas of land, not individual properties).',
        'street to parcels of land':
          'Street to Parcels of Land: Likely to be reliable for identifying individual properties at risk (though not whether they flood internally, so the information is suitable for areas of land, not individual properties).',
        'property (inc. internal)':
          'Property (inc. Internal): Likely to be very reliable at identifying individual properties at risk, including depths of flooding internally (this provides a genuine property level assessment).',
      },
    },
    vw_ufmfsw: {
      prob_4band: {
        high:
          'High - High risk means that each year this area has a chance of flooding of greater than 3.3%. Flooding from surface water is difficult to predict as rainfall location and volume are difficult to forecast. In addition, local features can greatly affect the chance and severity of flooding.',
        medium:
          'Medium - Medium risk means that each year this area has a chance of flooding of between 1% and 3.3%. Flooding from surface water is difficult to predict as rainfall location and volume are difficult to forecast. In addition, local features can greatly affect the chance and severity of flooding.',
        low:
          'Low - Low risk means that each year this area has a chance of flooding of between 0.1% and 1%. Flooding from surface water is difficult to predict as rainfall location and volume are difficult to forecast. In addition, local features can greatly affect the chance and severity of flooding.',
      },
      suitabilit: {
        'county to town':
          'County to Town: Unlikely to be reliable for a local area (suitable for identifying approximate extents, shallower and deeper areas).',
        'national to county':
          'National to County: Very unlikely to be reliable for a local area (Suitable for identifying areas with a natural vulnerability to flood first, deepest or most frequently).',
        'town to street':
          'Town to Street: Unlikely to be reliable for identifying individual properties at risk (and so the information is suitable for areas of land, not individual properties).',
        'street to parcels of land':
          'Street to Parcels of Land: Likely to be reliable for identifying individual properties at risk (though not whether they flood internally, so the information is suitable for areas of land, not individual properties).',
        'property (inc. internal)':
          'Property (inc. Internal): Likely to be very reliable at identifying individual properties at risk, including depths of flooding internally (this provides a genuine property level assessment).',
      },
    },
  };
  this.titlefilters = {
    freehold: "'AF','QF','PF','SF','CF'",
    leasehold: "'AL','GL','QL','PL','SL','CL'",
    other: "'AR','QR','PR','CN', 'PN'",
  };
  this.correctlistlayer = {
    linesearch: {
      description: 'Description',
      companies: 'Asset Owners',
    },
    linesearchNon: {
      description: 'Description',
      companies: 'Asset Owners',
    },
    linesearchUnaffected: {
      description: 'Description',
      companies: 'Asset Owners',
    },
    os_boundaryline_district_borough_unitary_2017_mhw_clip: {
      name: 'Local Authority',
    },
    vw_la_cil_data: {
      lad17nm: 'Local authority',
      cil_status: 'CIL Status',
      date: 'Date',
      residential: 'Residential Charges',
      retail_comm: 'Retail/Commercial Charges',
      others: 'Others',
    },
    vw_la_cil_data_dev: {
      lad17nm: 'Local authority',
      cil_status: 'CIL Status',
      date: 'Date',
      residential: 'Residential Charges',
      retail_comm: 'Retail/Commercial Charges',
      others: 'Others',
    },
    Local_Nature_Reserves_England: {
      status: 'Status',
      lnr_area: 'LNR Area',
      lnr_name: 'LNR Name',
      gis_date: 'Last Updated',
      exclude: ['area'],
    },
    National_Nature_Reserves_England: {
      status: 'Status',
      nnr_area: 'NNR Area',
      nnr_name: 'NNR Name',
      gis_date: 'Last Updated',
      reference: 'Reference',
      exclude: ['area'],
    },
    Special_Areas_of_Conservation_England: {
      status: 'Status',
      sac_area: 'SAC Area',
      sac_name: 'SAC Name',
      sac_code: 'SAC Code',
      gis_date: 'Last Updated',
      reference: 'Reference',
      exclude: ['area'],
    },
    NRW_SAC: {
      SAC_name: 'SAC Name',
      Site_code: 'SAC Code',
      Area_ha: 'SAC Area',
      Edit_date: 'Last Updated',
      Status: 'Designated',
    },
    NRW_SPA: {
      SPA_Name: 'SPA Name',
      SPA_code: 'SPA Code',
      CART_AREA: 'SAC Area',
      Edit_Date: 'Last Updated',
    },
    Special_Protection_Areas_England: {
      status: 'Status',
      spa_area: 'SPA Area',
      spa_name: 'SPA Name',
      spa_code: 'SPA Code',
      gis_date: 'Last Updated',
      reference: 'Reference',
      exclude: ['area'],
    },
    NRW_NNR: {
      Authority: 'Authority',
      CART_AREA: 'LNR Area',
      Edit_Date: 'Last Updated',
      NNR_Code: 'NNR Code',
      NNR_Name: 'NNR Name',
    },
    NRW_LNR: {
      Authority: 'Authority',
      CART_AREA: 'LNR Area',
      Edit_Date: 'Last Updated',
      ISIS_ID: 'LNR Code',
      LNR_Name: 'LNR Name',
    },
    vw_england_highways: {
      Origin: 'Category',
    },
    vw_scheduled_monuments: {
      name: 'Name',
      exclude: ['listentry'],
    },
    vw_designated_protected_areas: {
      dpa_coverage: 'Coverage',
      parish_name: 'Parish Name',
      parish_description: 'Parish Description',
      county: 'County',
      region: 'Region',
      legislation_gov_uk: 'Legislation',
      more_info: 'More Info',
    },
    n_norfolk_tpo: {
      LINKREF: 'Reference',
    },
    '3': {
      DESCRIPTIO: 'Description',
      SITE_REF: 'Site Reference',
      SITE_DESC: 'Site Description',
      REF: 'Reference',
    },
    '4': {
      DESCRIPTIO: 'Description',
      SITE_DESC: 'Site Description',
      REF: 'Reference',
    },
    '5': {
      LINKREF: 'Reference',
      LOCATION: 'Location',
    },
    '8': {
      LINKREF: 'Reference',
    },
    '22': {
      LINKREF: 'Reference',
      LOCATION: 'Location',
    },
    '27': {
      LINKREF: 'Reference',
      LOCATION: 'Location',
      ORN: 'ORN',
    },
    gla_article_4: {
      borough: 'Borough',
      classification: 'Classification',
      designation: 'Designation',
      planningauthority: 'Planning Authority',
      sitename: 'Site Name',
      source: 'Source',
    },
    gla_bid: {
      bid_name: 'Business Improvement District',
      borough: 'Borough',
      industrial_bid: 'Industrial BID',
      property_bid: 'Property BID',
      town_centre_bid: 'Town Centre BID',
    },
    gla_brownfield: {
      designation: 'Designation',
      organisationlabel: 'Organisation',
      ownershipstatus: 'Ownership',
      planningstatus: 'Planning Status',
      sitenameaddress: 'Site Name',
      exclude: ['source', 'siteplanurl', 'firstaddeddate', 'lastupdateddate', 'planninghistory'],
    },
    gla_conservation_areas: {
      borough: 'Borough',
      designation: 'Designation',
      sitename: 'Site Name',
      exclude: ['source'],
    },
    gla_designated_open: {
      borough: 'Borough',
      classification: 'Classification',
      designation: 'Designation',
      sitename: 'Site Name',
      notes: 'Notes',
      planningauthority: 'Planning Authority',
      firstaddeddate: 'First Added Date',
      lastupdateddate: 'Last Updated Date',
    },
    gla_housing_zones: {
      borough: 'Borough',
      designation: 'Designation',
      planningauthority: 'Planning Authority',
      sitename: 'Site Name',
      notes: 'Notes',
      source: 'Source',
    },
    gla_strategic_housing: {
      address: 'Address',
      extrainfo1: 'Extra Info 1',
      extrainfo2: 'Extra Info 2',
      extrainfo3: 'Extra Info 3',
      planningauthority: 'Planning Authority',
      sitename: 'Site Name',
      source: 'Source',
    },
    gla_sinc: {
      borough: 'Borough',
      classification: 'Classification',
      designation: 'Designation',
      sitename: 'Site Name',
      notes: 'Notes',
      planningauthority: 'Planning Authority',
      status: 'Status',
      source: 'Source',
    },
    gla_site_allocations: {
      borough: 'Borough',
      designation: 'Designation',
      sitename: 'Site Name',
      notes: 'Notes',
      planningauthority: 'Planning Authority',
      firstaddeddate: 'First Added Date',
      lastupdateddate: 'Last Updated Date',
    },
    gla_protected_vistas: {
      borough: 'Borough',
      designation: 'Designation',
      sitename: 'Site Name',
      extrainfo1: 'Extra Info 1',
      extrainfo2: 'Extra Info 2',
      extrainfo3: 'Extra Info 3',
      planningauthority: 'Planning Authority',
      exclude: ['source'],
    },
    England_Coast_Path_Route: {
      stretch: 'Stretch',
      section_id: 'Section ID',
      chapter: 'Chapter 4.2',
      status: 'Status',
      alt_route: 'Alternative Route',
      rollback: 'Rollback',
      pub_date: 'Publication Date',
    },
    article_4_2: {
      conservation_area: 'Conservation Area',
      source: 'Source',
      tpye: 'Type',
      date: 'Date',
    },
    article_4_polygon: {
      refno: 'Reference Number',
      code: 'Code',
      description: 'Description',
    },
    AM_S_IDOXTreePreservation_POLY_CURRENT: {
      DATE_MODIFIED: 'Date Modified',
      TREETYPE: 'Tree Type',
      DESCRIPT: 'Description',
      ADDRESS: 'Address',
      TPSTATUS: 'Status',
    },
    AM_S_IDOXTreePreservation_POINT_CURRENT: {
      DATE_MODIFIED: 'Date Modified',
      TREETYPE: 'Tree Type',
      DESCRIPT: 'Description',
      ADDRESS: 'Address',
      TPSTATUS: 'Status',
    },
  };

  this.correctlist = {
    'title:AM_S_IDOXTreePreservation_POINT_CURRENT': 'CW TPO Points',
    'title:AM_S_IDOXTreePreservation_POLY_CURRENT': 'CW TPO Polygons',
    'title:utility_data_dev': 'Utilities',
    'title:Local_Nature_Reserves_England': 'Local Nature Reserves',
    'title:vw_designated_protected_areas': 'Designated Protected Areas',
    'title:National_Nature_Reserves_England': 'National Nature Reserves',
    'title:Special_Areas_of_Conservation_England': 'Special Areas of Conservation',
    'title:Special_Protection_Areas_England': 'Special Protection Areas England',
    'title:NRW_SAC': 'Special Areas of Conservation',
    'title:NRW_SPA': 'Special Protection Areas',
    'title:NRW_LNR': 'Local Nature Reserves',
    'title:NRW_NNR': 'National Nature Reserves',
    'title:Risk_of_Flooding_from_Surface_Water_Extent_3_3_percent_annual_chance': 'Surface Water - High',
    'title:surface-water-3-3': 'Surface Water - High',
    'title:Risk_of_Flooding_from_Surface_Water_Extent_1_percent_annual_chance': 'Surface Water - Medium',
    'title:surface-water-1': 'Surface Water - Medium',
    'title:Risk_of_Flooding_from_Surface_Water_Extent_0_1_percent_annual_chance': 'Surface Water - Low',
    'title:surface-water-0-1': 'Surface Water - Low',
    'title:vw_dlr': 'DLR',
    'title:NRW_HISTORIC_FLOODMAP': 'Historic Flood Outlines',
    'title:vw_cheshire_brine_area': 'Cheshire Brine',
    'title:vw_ufmfsw': 'Surface Water Flooding',
    'title:AM_S_LocalPlanMineralsPeakDistrictNationalPark_POLY_CURRENT': 'Peak District National Park',
    'title:AM_S_LocalPlanMineralsExistingQuarry_POLY_CURRENT': 'Existing Quarry',
    'title:AM_S_LocalPlanMineralsAreaofPreferredExtensionforSandandGravelExtraction_POLY_CURRENT':
      'Area of Preferred Extension for Sand and Gravel Extraction',
    'title:AM_S_LocalPlanMineralsAreaOfSearchforSandandGravel_POLY_CURRENT': 'Area Of Search for Sand and Gravel',
    'title:AM_S_LocalPlanMineralsAreaOfPreferredExtensiontoExistingSilicaSandQuarry_POLY_CURRENT':
      'Area Of Preferred Extension to Existing Silica Sand Quarry',
    'title:AM_S_LocalPlanMineralsAreaOfPreferredExtensiontoExistingSaltMine_POLY_CURRENT':
      'Area Of Preferred Extension to Existing Salt Mine',
    'title:AM_S_LocalPlanMineralsAreaOfPreferredExtensiontoControlledBrinefield_POLY_CURRENT':
      'Area Of Preferred Extension to Controlled Brinefield',
    'title:AM_S_Smokecon_POLY_CURRENT': 'Cheshire East Smoke Control Area',
    'title:LU_S_TPO_PNT_current': "Cheshire East TPO's",
    'title:LU_SD_HBSMRArchaeologicalCharacterZones_POLY_CURRENT': 'Cheshire East Archaeological Character Zones',
    'title:PS_SD_HBSMRAreasOfArchaeologicalPotential_POLY_CURRENT': 'Cheshire East Archaeological Potential',
    'title:LU_S_TPO_POLY_current': "Cheshire East TPO's",
    'title:AM_S_BrownfieldRegisterSites_POLY_CURRENT': 'Cheshire East Brownfield Register Sites',
    'title:AM_S_CheshireEastLocalPlanStrategy_POLY_2010to2030': 'Cheshire East Local Plan Strategy',
    'title:vw_prow_find': 'Public Rights of Way',
    'title:34': 'Privately Maintained Highways',
    'title:36': 'Highways Extent',
    'title:74': 'Tree Preservation Orders',
    'title:28': 'Development Pipeline',
    'title:66': 'City Development Pipeline',
    'title:vw_os_boundaryline_district_borough_unitary_mhw_clip': 'Boundaries',
    'title:vw_aonb': 'AONB',
    'title:vw_ne_sssi_england': 'SSSI',
    'title:ne_sssi_wales': 'SSSI',
    'title:vw_crow_access': 'Common Land &amp; Greens',
    'title:vw_crow_section_15_land': 'Common Land &amp; Greens (Sec.15)',
    'title:vw_parksandgardens': 'Parks and Gardens',
    'title:vw_scheduled_monuments': 'Scheduled Monuments',
    'title:vw_scheduled_monuments_dev': 'Scheduled Monuments',
    'title:he_scheduled_monuments': 'Scheduled Monuments',
    'title:he_scheduledmonuments_26_01_2018': 'Scheduled Monuments',
    'title:he_scheduled_monuments_032020': 'Scheduled Monuments',
    'title:vw_greenbelt': 'Greenbelt',
    'title:greenbelt_2018_19': 'Greenbelt',
    'title:vw_conservation_areas': 'Conservation Areas',
    'title:vw_listed_buildings': 'Listed Buildings',
    'title:listed_buildings_032020': 'Listed Buildings',
    'title:listed_buildings_new': 'Listed Buildings',
    'title:listed_buildings_2019': 'Listed Buildings',
    'title:rofrs_ea_v201905': 'Flood Zones',
    'title:vw_rofrs': 'Flood Zones',
    'title:vw_rofrs_157': 'Flood Zones',
    'title:ea_flood': 'EA Flood Risk',
    'title:roadlink': 'Road',
    'title:street_lookup': 'Road',
    'title:hazard': 'Road Hazard',
    'title:structure': 'Road Structure',
    'title:accessrestriction': 'Access Restriction',
    'title:restrictionforvehicles': 'Restrictions for Vehicles',
    'title:turnrestriction_lookup': 'Turn Restriction',
    'title:reinstatement': 'Reinstatement',
    'title:maintenance': 'Maintenance',
    'title:highways': 'Highways',
    'title:vw_england_highways': 'Highways England',
    'title:os_highways_street': 'Highways',
    'title:os_highways_street_lookup_nousrn_2020_01': 'Highways',
    'title:vw_os_highways_street': 'Highways',
    'title:vw_os_highways_street_live2': 'Highways',
    'title:vw_os_highways_street_live1': 'Highways',
    'title:vw_os_highways_street_dev': 'Highways',
    'title:vw_os_highways_hazard': 'Hazard',
    'title:vw_os_highways_hazard_live2': 'Hazard',
    'title:vw_os_highways_hazard_live1': 'Hazard',
    'title:vw_os_highways_hazard_dev': 'Hazard',
    'title:vw_os_highways_structure_point': 'Structure',
    'title:vw_os_highways_structure_point_live2': 'Structure',
    'title:vw_os_highways_structure_point_live1': 'Structure',
    'title:vw_os_highways_structure_point_dev': 'Structure',
    'title:vw_os_highways_structure': 'Structure',
    'title:vw_os_highways_structure_live2': 'Structure',
    'title:vw_os_highways_structure_live1': 'Structure',
    'title:vw_os_highways_structure_dev': 'Structure',
    'title:vw_os_highways_restriction': 'Rectriction',
    'title:vw_os_highways_restriction_live2': 'Rectriction',
    'title:vw_os_highways_restriction_live1': 'Rectriction',
    'title:vw_os_highways_restriction_dev': 'Rectriction',
    'title:vw_os_highways_specialdesignation': 'Designation',
    'title:vw_os_highways_specialdesignation_live2': 'Designation',
    'title:vw_os_highways_specialdesignation_live1': 'Designation',
    'title:vw_os_highways_specialdesignation_dev': 'Designation',
    'title:vw_os_highways_restrictionforvehicles': 'Rectriction',
    'title:vw_os_highways_restrictionforvehicles_live2': 'Rectriction',
    'title:vw_os_highways_restrictionforvehicles_live1': 'Rectriction',
    'title:vw_os_highways_restrictionforvehicles_dev': 'Rectriction',
    'title:vw_os_highways_maintenance': 'Maintenance',
    'title:vw_os_highways_maintenance_live2': 'Maintenance',
    'title:vw_os_highways_maintenance_dev': 'Maintenance',
    'title:vw_os_highways_street_live': 'Highways',
    'title:vw_os_highways_hazard_live': 'Hazard',
    'title:vw_os_highways_structure_point_live': 'Structure',
    'title:vw_os_highways_structure_live': 'Structure',
    'title:vw_os_highways_restriction_live': 'Rectriction',
    'title:vw_os_highways_restrictionforvehicles_live': 'Rectriction',
    'title:vw_os_highways_maintenance_live': 'Maintenance',
    'title:vw_os_highways_maintenance_point_live1': 'Maintenance',
    'title:vw_os_highways_maintenance_point_live2': 'Maintenance',
    'title:vw_os_highways_street_test': 'Highways',
    'title:vw_os_highways_street_lookup_test': 'Highways',
    'title:vw_os_highways_hazard_test': 'Hazard',
    'title:vw_os_highways_structure_point_test': 'Structure',
    'title:vw_os_highways_structure_test': 'Structure',
    'title:vw_os_highways_restriction_test': 'Rectriction',
    'title:vw_os_highways_restrictionforvehicles_test': 'Rectriction',
    'title:vw_os_highways_maintenance_test': 'Maintenance',
    'title:vw_thames_tideway_tunnel': 'Thames Tideway Tunnel',
    'title:underground_lines': 'Underground Line',
    'title:underground_routes': 'Underground Line',
    'title:vw_underground_routes': 'Underground Line',
    'title:tb_underground_routes_old': 'Underground Lines',
    'title:underground_stations': 'Underground Stations',
    'title:vw_underground_stations': 'Underground Stations',
    'title:vw_mail_rail_route': 'Mail Rail Lines',
    'title:vw_mail_rail_stations': 'Mail Rail Stations',
    'title:planningapplications': 'Planning Applications',
    'title:linesearch': 'Known Affected Utilities',
    'title:linesearchNon': 'Non LSBUD Members',
    'title:linesearchUnaffected': 'Non Affected Utilities',
    'title:vw_bgs_radon_gb_atlas': 'Radon',
    'title:tb_hs2_phase1': 'HS2',
    'title:tb_hs2_phase2_2016': 'HS2',
    'title:crossrail': 'Crossrail',
    'title:crossrail_route': 'Crossrail',
    'title:vw_crossrail_route': 'Crossrail',
    'title:crossrail_station': 'Crossrail Station',
    'title:vw_crossrail_station': 'Crossrail Station',
    'title:vw_crossrail_2': 'Crossrail',
    'title:vw_crossrail_2_stations': 'Crossrail Station',
    'title:tb_crossrail_stations': 'Crossrail Station',
    'title:tb_crossrail': 'Crossrail',
    'title:vw_historic_landfill_sites': 'Historic Landfill',
    'title:vw_authorised_landfill_sites': 'Permitted Sites',
    'title:Recorded_Flood_Outlines': 'Historic Flood Outlines',
    'title:Abandoned': 'CA Abandoned Mines',
    'title:Mine': 'CA Mine Entries',
    'title:Development': 'CA Development High Risk Areas',
    'title:gla_article_4': 'GLA Article 4',
    'title:gla_brownfield': 'GLA Brownfield Sites',
    'title:gla_conservation_areas': 'GLA Conservation Areas',
    'title:gla_housing_zones': 'GLA Housing Zones',
    'title:gla_strategic_housing': 'GLA Strategic Housing',
    'title:gla_designated_open': 'GLA Designated Open Spaces',
    'title:gla_sinc': 'GLA Site of Importance for Nature Conservation',
    'title:gla_site_allocations': 'GLA Site Allocations',
    'title:gla_protected_views': 'GLA Protected Views',
    'title:cil': 'Comminity Infrastructure Levy',
    'title:vw_la_cil_data': 'Comminity Infrastructure Levy',
    'title:vw_la_cil_data_dev': 'Comminity Infrastructure Levy',
    'title:article_4_2': 'Stockport Article 4.2',
    'title:article_4_1': 'Stockport Article 4.1',
    'title:compulsory_purchase_orders': 'Stockport Compulsory Purchase Orders',
    'title:pt4_cpo': 'Stockport Compulsory Purchase Orders',
    'title:conservation_area': 'Stockport Conservation Areas',
    'title:section106_landcharge': 'Stockport Section 106',
    'title:smoke_control_area': 'Stockport Smoke Control Area',
    'title:tpo_merged': 'Stockport TPOs',
    'title:adopted_highway_bng': 'Stockport Highways Extent',
    'title:article_4_polygon': 'West Dorset Article 4',
    'title:tpo_polygon': 'West Dorset TPOs',
    sac_name: 'SAC Name',
    sac_code: 'SAC Code',
    sac_area: 'Area',
    status: 'Status',
    lnr_area: 'LNR Area',
    lnr_name: 'LNR Name',
    gis_date: 'Last Updated',
    CatalogueNumber: 'Catalogue Number',
    Address: 'Address',
    DateConstructionCommenced: 'Date Construction Commenced',
    DevelopmentStatus: 'Development Status',
    PermissionType: 'Permission Type',
    PlanningAppNumber: 'Planning Application No.',
    Description: 'Description',
    flood_caus: 'Flood Cause',
    flood_src: 'Flood Source',
    authority: 'Authority',
    //    description: "Description",
    last_update: 'Last Update',
    type: 'Type',
    row_code: 'RoW Code',
    RoadClass: 'Road Class',
    RoadName: 'Road Name',
    desig_date: 'Designated Date',
    descriptio: 'Description',
    created: 'Created Date',
    class_max: 'Class',
    percent_exceeding_radon_action_level: 'Exceeding Action Level',
    area: 'Hectares',
    common: 'Common Name',
    county_id: 'County',
    of_act: 'Official Act',
    entered: 'Entered By',
    checked_by: 'Checked By',
    address: 'Address',
    current_occupier: 'Current Occupier',
    uprn: 'UPRN',
    title_no: 'Title Number',
    regdatre: 'First Registered',
    //scheddate: 'First Scheduled',
    phase: 'Phase',
    parish: 'Parish',
    station_na: 'Station',
    amenddaate: 'Amended',
    area_ha: 'Hectares',
    gb_name: 'Name',
    la_name: 'Local Authority',
    year: 'Year',
    sssi_name: 'Name',
    unit_area: 'Hectares',
    condition: 'Condition',
    cond_date: 'Condition Date',
    modified: 'Date Modified',
    insert_date: 'Title Insert Date',
    update_date: 'Title Update Date',
    estate_interest: 'Estate',
    class_of_title: 'Class',
    registered_status: 'Status',
    primary_desc: 'Primary Class',
    secondary_desc: 'Secondary Class',
    tertiary_desc: 'Tertiary Class',
    name: 'Name',
    date_of_en: 'Date of Entry',
    grade: 'Grade',
    source: 'Source',
    lpa: 'LPA',
    designated: 'Designated',
    updated: 'Updated',
    data_source: 'Source',
    prob_4band: 'Probability',
    suitabilit: 'Suitability',
    pub_date: 'Published Date',
    risk_for_i: 'Insurance Risk',
    //    lb_uid: "Link",
    //listentry: 'Link',
    hyperlink: 'Link',
    extract_url: 'Link',
    formofway: 'Form of Way',
    hazard: 'Hazard Type',
    structure: 'Structure Type',
    roadname: 'Road Name',
    roadclassification: 'Road Classification',
    roadclassificationnumber: 'Road Number',
    length: 'Length',
    trafficsign: 'Traffic Sign',
    restriction: 'Restriction',
    maintenanceresponsibility: 'Responsibility',
    reinstatementtype: 'Type',
    vehicle: 'Vehicle',
    highwayauthorityname: 'Highway Authority',
    responsibleauthority_authority: 'Highway Authority',
    maintenanceauthorityname: 'Maintenance Authority',
    use: 'Use',
    price_paid: 'Price Paid',
    country_incorporated_1: 'Incorporated',
    address1: 'Proprietor 1',
    proprietor_name_1: 'Proprietor Name 1',
    address2: 'Proprietor 2',
    proprietor_name_2: 'Proprietor Name 2',
    address3: 'Proprietor 3',
    proprietor_name_3: 'Proprietor Name 3',
    address4: 'Proprietor 4',
    property_address: 'Title Address/Location',
    proprietor_name_4: 'Proprietor Name 4',
    proprietorship_1: 'Proprietorship 1',
    proprietorship_2: 'Proprietorship 2',
    proprietorship_3: 'Proprietorship 3',
    proprietorship_4: 'Proprietorship 4',
    proprietorship: 'Proprietorship',
    correspondence_address: 'Address',
    operationalstate: 'Operational State',
    operationalstate_state: 'Operational State',
    load: 'Load',
    corporate: 'corporate',
    daylist: 'daylist',
    company_registration_no_1: 'Company Reg No. 1',
    company_registration_no_2: 'Company Reg No. 2',
    company_registration_no_3: 'Company Reg No. 3',
    company_registration_no_4: 'Company Reg No. 4',
    proprietorship_category_1: 'Proprietorship 1',
    proprietorship_category_2: 'Proprietorship 2',
    proprietorship_category_3: 'Proprietorship 3',
    proprietorship_category_4: 'Proprietorship 4',
    non_pi_name: 'Proprietor Name',
    proprietor_1_address_1: 'Proprietor Address 1',
    proprietor_2_address_1: 'Proprietor Address 2',
    proprietor_3_address_1: 'Proprietor Address 3',
    proprietor_4_address_1: 'Proprietor Address 4',
    proprietor_1_address_2: 'Proprietor Address 2',
    proprietor_1_address_3: 'Proprietor Address 3',
    proprietor_1_address_4: 'Proprietor Address 4',
    proprietor_2_address_2: 'Proprietor Address 2',
    proprietor_2_address_3: 'Proprietor Address 3',
    proprietor_2_address_4: 'Proprietor Address 4',
    tenure: 'Tenure',
    date_proprietor_added: 'Date Added',
    change_date: 'Change Date',
    abr: 'Application Barcode Ref:',
    application_service_name: 'Application Service Name',
    application_type_code: 'Application Type Code',
    application_group: 'Application Group',
    dealing_code: 'Dealing Code',
    lodged_by: 'Lodged By',
    customer_reference: 'Customer Reference',
    intake_date: 'Intake Date',
    reg_addr_a1: 'Registered Address',
    completed_date: 'Completed Date',
    application_status: 'Status',
    applicant_name: 'Applicant Name',
    agent_name: 'Agent Name',
    distance: 'Distance from Centre',
    date_received: 'Date Received',
    decision_date: 'Decision Date',
    decision: 'Decision',
    ref: 'Reference',
    status_derived: 'Status',
    title: 'Description',
    designation: 'Designation',
    designation_description: 'Designation Desc',
    cl_no: 'Description',
    site_add: 'Site Address',
    site_ref: 'Waster Reg Auth Licence No.',
    lic_hold: 'Licence Holder',
    siteopname: 'Site Operator',
    lic_issue: 'Issue of Licence',
    inert: 'Waste Deposited - Inert',
    industrial: 'Waste Deposited - Industrial',
    commercial: 'Waste Deposited - Commercial',
    household: 'Waste Deposited - Household',
    special: 'Waste Deposited - Special',
    liqsludge: 'Waste Deposited - Liquid Sludge',
    wasteunk: 'Waste Deposited - Unknown',
    gascontrol: 'Gas Control Measures Installed',
    leachatecnt: 'Leachate Control Measures Installed',
    licenced: 'Waste Disposal/Management Licencing',
    nolicreq: 'No Licence Required',
    exempt: 'Exempt from Licencing',
    buff_point: 'Buffered Point',
    add_source: 'Address Source',
    add_source_descr: 'Description',
    county: 'County',
    country: 'Country',
    link: 'More Info',
    lic_ippcr: 'IPPC Reference No.',
    lic_ltype: 'Licence Holder Type',
    lic_name: 'Licence Holder Name',
    site_name: 'Facility Name',
    site_build: 'Facility Building',
    site_town: 'Facility Town',
    site_pcode: 'Facility Postcode',
    type_desc: 'Licence Type',
    date_issue: 'Licence Issued',
    lic_epr: 'Permit Number',
    route_sect: 'Route Section',
    ROUTE_TYPE: 'Route Type',
    STATION_NA: 'Station',
    sur_tun: 'Surface or Tunnel',
    for_eng: 'Section Type',
    ensis_id: 'Link',
    HYPERLINK: 'Link',
    REFERNCE: 'Reference',
    Type: 'Type',
    FEATURE_TYPE: 'Feature Type',
    TPSTATUS: 'TPS Status',
    TREETYPE: 'Tree Type',
    CASENO: 'Case Number',
    DATE_MODIFIED: 'Date Modified',
    REFVAL: 'Reference',
    BuildingName: 'Building Name',
    BuildingNumber: 'Building Number',
    PrimaryStreet: 'Primary Street',
    SecondaryAddress: 'Secondary Address',
    Postcode: 'Postcode',
    PlanningReferenceNumber: 'Planning Ref Number',
    CPATStatus: 'Status',
    DevelopmentType: 'Development Type',
    MARKETING_WEBSITE: 'Marketing Website',
    EARLIEST_START_YEAR: 'Earliest Start Year',
    EARLIEST_COMPLETION_YEAR: 'Earliest Completion Year',
    sitenameaddress: 'Site Name &amp; Address',
    developmentdescription: 'Development Description',
    firstaddeddate: 'First Added Date',
    hazardoussubstances: 'Hazardous Substances',
    //    hectares: "Hectares",
    lastupdateddate: 'Last Updated Date',
    minnetdwellings: 'Min Net Dwellings',
    nonhousingdevelopment: 'Non Housing Development',
    ownershipstatus: 'Ownership Status',
    part2: 'Part 2',
    permissiondate: 'Permission Date',
    permissiontype: 'Permission Type',
    planninghistory: 'Planning History',
    planningstatus: 'Planning Status',
    sitereference: 'Site Reference',
    siteplanurl: 'More Info',
    DOCUMENT: 'Document',
    Policy: 'Policy No.',
    Name: 'Name',
    Info: 'Description',
    Add_Info: 'Additional Info',
    Date: 'Date',
    Orig_Auth: 'Original Authority',
    Reference: 'Reference',
    Street: 'Street',
    Section: 'Section',
    'Title of Order': 'Title of Order',
    'APAS Code': 'Reference',
    Comments: 'Comments',
    'Date of service': 'Date',
    'HMLR Land_Description': 'Description',
    'HMLR Originating Authority': 'Originating Authority',
    Species: 'Species',
    Adopt_Ref: 'Adoption Reference',
    Draft_Ref: 'Draft Reference',
    Ha: 'Area Ha',
    Id: 'ID',
    Link: 'Link',
    Site: 'Site Name',
    DesigUID: 'Designation ID',
    LastEditedBy: 'Last Edited Date',
    RCP_ArcGIS: 'Link',
    BroadTypeDesc: 'Description',
    HLCTypeDesc: 'Character Zone',
    HLCUID: 'Zone ID',
    Archaeological_Potential: 'Archaeological Potential',
    Preservation_Potential: 'Preservation Potential',
    Designatio: 'Designation',
    Start_Date: 'Start Date',
    Check_: 'Checked Date',
    End_Date: 'End Date',
    LINK: 'Link',
    'cheshire_brine_area.link': 'More Info',
    'cheshire_brine_area.map': 'Map',
    'cheshire_brine_area.name': 'Name',
    NAME: 'Name',
    COMMENTS: 'Comments',
    START_DATE: 'Start Date',
    FLOOD_SOURCE_TYPE_RESOLVED: 'Flood Source Type Resolved',
    FLOOD_CAUSE_RESOLVED: 'Flood Cause Resolved',
    FLOOD_MAP_STATUS_RESOLVED: 'Flood Map Status Resolved',
    HFM_STATUS_RESOLVED: 'HFM Status Resolved',
    DATA_SOURCE_RESOLVED: 'Data Source Resolved',
    FLOOD_TYPE_FLUVIAL_RESOLVED: 'Flood Type Fluvial Resolved',
    FLOOD_TYPE_COASTAL_RESOLVED: 'Flood Type Coastal Resolved',
    FLOOD_TYPE_TIDAL_RESOLVED: 'Flood Type Tidal Resolved',
    bridge: 'Bridge',
    tunnel: 'Tunnel',
    linetype: 'Utility Type',
    LOCALAUTHO: 'Local Authority',
    STATUS: 'Status',
    EZ_Website: 'More Info',
  };
  this.exclude = {
    stockport_tpo_combined: ['type'],
    permitted_waste: ['area'],
    tb_conservation_areas_2017: ['data_source'],
    gla_brownfield: ['source', 'siteplanurl', 'firstaddeddate', 'lastupdateddate', 'planninghistory'],
    Local_Nature_Reserves_England: ['area'],
    National_Nature_Reserves_England: ['area'],
    Special_Areas_of_Conservation_England: ['area'],
    Special_Protection_Areas_England: ['area'],
    gla_conservation_areas: ['source', 'lastupdateddate', 'firstaddeddate'],
    gla_protected_vistas: ['source', 'lastupdateddate', 'firstaddeddate'],
    gla_strategic_housing: ['source', 'sitereference', 'status', 'designation'],
    gla_sinc: ['sitereference', 'lastupdateddate', 'firstaddeddate'],
    gla_article_4: ['source'],
    gla_housing_zones: ['source'],
  };
  this.corrections = {
    'gla_housing_zones:source': 'modifyurl7',
    'gla_article_4:source': 'modifyarticle4',
    'gla_strategic_housing:source': 'modifyurl7',
    'gla_protected_vistas:source': 'modifyurl7',
    'article_4_2:date': 'chopdate',
    DATE_MODIFIED: 'chopdate',
    EZ_Website: 'modifyurlez',
    date_registered: 'chopdate',
    gis_date: 'chopdate',
    LastEditedBy: 'chopdate',
    Edit_Date: 'chopdate',
    Edit_date: 'chopdate',
    hectares: 'addhect',
    cl_no: 'CRoW_desc',
    entered: 'add20',
    lic_epr: 'remove_epr',
    percent_exceeding_radon_action_level: 'percent',
    checked_by: 'add20',
    created: 'chopdate',
    date_of_en: 'stripalpha',
    lb_uid: 'modifyurl',
    'vw_listed_buildings:hyperlink': 'modifyurl7',
    hyperlink: 'modifyurl2',
    web_info_link: 'stockport_cons',
    HYPERLINK: 'modifyurl7',
    web_db_link: 'modifyurl7',
    link: 'modifyurl7',
    extract_url: 'modifyurl3',
    listentry: 'modifyurl4',
    pub_date: 'chopdate',
    length: 'addmeter',
    designated: 'standardize',
    START_DATE: 'chopdate',
    insert_date: 'chopdate',
    update_date: 'chopdate',
    last_update: 'chopdate',
    date_proprietor_added: 'chopdate',
    desision_date: 'chopdate',
    date_received: 'chopdate',
    change_date: 'chopdate',
    updated: 'standardize',
    cond_date: 'chopdate',
    modified: 'chopdate',
    price_paid: 'currency',
    area: '2dp',
    lnr_area: '2dpcomma',
    nnr_area: '2dpcomma',
    ha: '2dpcomma',
    Ha: '2dpcomma',
    CART_AREA: '2dpcomma',
    area_ha: '2dpcomma',
    Area_ha: '2dpcomma',
    unit_area: '2dp',
    descriptio: 'crowfix',
    completed_date: 'chopdate',
    decision_date: 'chopdate',
    intake_date: 'chopdate',
    source: 'titlecase',
    status_derived: 'capitalize',
    maintenanceresponsibility: 'titlecase',
    risk_for_insurance_sop: 'addflood',
    designation_description: 'addMPH',
    date_issue: 'chopdate',
    scheddate: 'chopdate',
    ensis_id: 'modifyurl6',
    lic_issue: 'chopdate',
    planninghistory: 'modifyurl3',
    siteplanurl: 'modifyurl7',
    Link: 'modifyurl7',
    map: 'modifyurl7',
    RCP_ArcGIS: 'modifyurl7',
    LINK: 'modifyurl7',
    legislation_gov_uk: 'modifyurl7',
    more_info: 'modifyurl7',
    permissiondate: 'chopdate',
    firstaddeddate: 'chopdate',
    lastupdateddate: 'chopdate',
    Start_Date: 'chopdate',
    'Date of service': 'chopdate',
    roadclassification: 'usrn',
    bridge: 'truefalse',
    tunnel: 'truefalse',
    county: 'replaceUnderscore',
  };
  this.toabsbottom = [
    'modifyurl4',
    'EZ_Website',
    'hyperlink',
    'HYPERLINK',
    'extract_url',
    'listentry',
    'ensis_id',
    'LINK',
    'for_eng',
  ];
  this.tobottom = ['lb_uid', 'area_ha', 'cl_no', 'unit_area', 'link', 'last_update', 'siteplanurl'];
  this.totop = ['prob_4band', 'type', 'roadname', 'site_name', 'proprietor_name_1', 'Name', 'name'];
  //  this.totop = ["designatedname1", "roadname"];
  this.layergroups = [
    'roadlink',
    'street_lookup',
    'hazard',
    'structure',
    'accessrestriction',
    'restrictionforvehicles',
    'turnrestriction_lookup',
    'reinstatement',
    'maintenance',
    'highways',
    'os_highways_street',
    'os_highways_street_lookup_nousrn_2020_01',
    'vw_os_highways_street',
    'vw_os_highways_street_live2',
    'vw_os_highways_street_live1',
    'vw_os_highways_hazard',
    'vw_os_highways_hazard_live2',
    'vw_os_highways_hazard_live1',
    'vw_os_highways_structure_point',
    'vw_os_highways_structure_point_live2',
    'vw_os_highways_structure_point_live1',
    'vw_os_highways_structure',
    'vw_os_highways_structure_live2',
    'vw_os_highways_structure_live1',
    'vw_os_highways_restriction',
    'vw_os_highways_restriction_live2',
    'vw_os_highways_restriction_live1',
    'vw_os_highways_specialdesignation',
    'vw_os_highways_specialdesignation_live2',
    'vw_os_highways_specialdesignation_live1',
    'vw_os_highways_restrictionforvehicles',
    'vw_os_highways_restrictionforvehicles_live2',
    'vw_os_highways_restrictionforvehicles_live1',
    'vw_os_highways_maintenance',
    'vw_os_highways_maintenance_live2',
    'vw_os_highways_street_live',
    'vw_os_highways_hazard_live',
    'vw_os_highways_structure_point_live',
    'vw_os_highways_structure_live',
    'vw_os_highways_restriction_live',
    'vw_os_highways_restrictionforvehicles_live',
    'vw_os_highways_maintenance_live',
    'vw_os_highways_maintenance_point_live1',
    'vw_os_highways_maintenance_point_live2',
    'vw_os_highways_street_test',
    'vw_os_highways_street_lookup_test',
    'vw_os_highways_hazard_test',
    'vw_os_highways_structure_point_test',
    'vw_os_highways_structure_test',
    'vw_os_highways_restriction_test',
    'vw_os_highways_restrictionforvehicles_test',
    'vw_os_highways_maintenance_test',
  ];
}
Utils.prototype.labelfilters = function (f, l, o) {
  var arr = [];
  if (f) arr = arr.concat(['AF', 'QF', 'PF', 'SF', 'CF']);
  if (l) arr = arr.concat(['AL', 'GL', 'QL', 'PL', 'SL', 'CL']);
  if (o) arr = arr.concat(['AR', 'QR', 'PR', 'CN', 'PN']);
  return 'class_of_title_code IN (' + arr.join(',') + ')';
};

Utils.prototype.getLogo = function ({ state, layer, layer2 }) {
  var logo;
  if (layer.includes('highway') && !layer.includes('england') && !layer.includes('adopted')) {
    logo = this.logoData['highways'];
  } else {
    if (state.wmsQuery) logo = this.logoData[`${state.wmsQuery[layer]}`] || this.logoData[layer];
    else logo = this.logoData[layer];
  }
  if (!logo) {
    logo = this.logoData[layer2];
  }
  if (logo) {
    var logoTitle = logo.title;
    var logoLogo = logo.logo;
    if (this.country === 'Wales' && logo.titleWales) {
      logoTitle = logo.titleWales;
      logoLogo = logo.logoWales;
    }
    return (
      '<tr><td>&nbsp;</td></tr>' +
      `${
        !logo.noOGL
          ? '<tr><td style="padding-bottom:10px"><a class="white" target="_blank" href="http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/">Contains public sector information licensed under the Open Government Licence v3.0.</a></td></tr>'
          : ''
      }` +
      "<tr style='border-top:1px white solid;'><td style='padding-top:16px;' colspan='2'>" +
      logoTitle +
      '</td></tr>' +
      "<tr><td colspan='2'><img style='height:" +
      (logo.height ? logo.height : '64px') +
      ";margin-top:10px' src='/assets/img/logos/" +
      logoLogo +
      "' /></td></tr>"
    );
  } else {
    return '';
  }
};
Utils.prototype.buildRadon = function (class_max) {
  var rd = this.radondata[class_max.toString()];
  return (
    '<tr><td class="left-float"><b>Radon Affected Area:</b></td><td class="right-float" id="attr_affected">' +
    rd.affected +
    '</td></tr>' +
    '<tr><td class="left-float"><b>Class:</b></td><td class="right-float" id="attr_class">' +
    class_max.toString() +
    '</td></tr>' +
    '<tr><td class="left-float"><b>Exceeding Action Level:</b></td><td class="right-float" id="attr_level">' +
    rd.action +
    '</td></tr>' +
    '<tr><td class="left-float"><b>Probability:</b></td><td class="right-float" id="attr_prob">' +
    rd.prob +
    '</td></tr>' +
    '<tr><td class="left-float"><b>Protective Measures Required for New Buildings:</b></td><td class="right-float" id="attr_prob">' +
    rd.prot +
    '</td></tr>' +
    '<tr><td class="left-float"><b>Required Measure:</b></td><td class="right-float" id="attr_prob">' +
    rd.req +
    '</td></tr>' +
    '<tr></tr><tr><td class="left-float"><b>Link:</b></td><td class="right-float"><a target="_blank" href="http://www.ukradon.org/radonmaps/" style="cursor: pointer;">UK Radon Map</a></td></tr>'
  );
};
Utils.prototype.lookup = function (cat, section, phrase) {
  var retVal = phrase;
  if (
    typeof this.definitions[cat] !== 'undefined' &&
    typeof this.definitions[cat][section] !== 'undefined' &&
    typeof this.definitions[cat][section][phrase.toLowerCase()] !== 'undefined'
  )
    retVal = this.definitions[cat][section][phrase.toLowerCase()];
  return retVal;
};

Utils.prototype.correct = function (word, layer) {
  let cll;
  if (window.state.wmsQuery) cll = this.correctlistlayer[window.state.wmsQuery[layer]] || this.correctlistlayer[layer];
  else cll = this.correctlistlayer[layer];
  if (cll) {
    if (typeof cll[word] !== 'undefined') {
      return cll[word];
    } else if (cll.exclude && cll.exclude.includes(word)) {
      return null;
    } else if (typeof this.correctlist[word] !== 'undefined') {
      return this.correctlist[word];
    } else {
      return null;
    }
  } else if (typeof this.correctlist[layer + '.' + word] !== 'undefined') {
    return this.correctlist[layer + '.' + word];
  } else if (typeof this.correctlist[word] !== 'undefined') {
    return this.correctlist[word];
  } else if (this.correctlist[word] === 'null' || this.correctlist[word] === 'Null') {
    return null;
  } else {
    return null;
  }
};

Utils.prototype.generalFixes = function (val) {
  const retval = val && typeof val === 'string' ? val.replace('ï¿½', '£') : val;
  return retval;
};
Utils.prototype.modify = function (key, value, layer) {
  const corr = this.corrections[`${layer}:${key}`] || this.corrections[key];
  var retVal = this.generalFixes(value);
  var t;
  if (typeof corr !== 'undefined') {
    if (corr == 'stripalpha') {
      retVal = value.replace(/[A-Za-z]/g, '');
      t = retVal.substring(0, 10).split('-');
      retVal = t[2] + '-' + t[1] + '-' + t[0];
    } else if (corr == 'CRoW_desc') {
      retVal =
        'Land subject to pre-existing public access rights that on CRoW access land apply instead of the CRoW rights.';
    } else if (corr == 'addMPH') {
      if (parseInt(value).toString() == value) {
        retVal = value + ' MPH';
      }
    } else if (corr == 'addhect') {
      retVal = value + ' hectares';
    } else if (corr == 'capitalize') {
      retVal = value.charAt(0).toUpperCase() + value.slice(1);
    } else if (corr == 'titlecase') {
      var splitStr = value.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      retVal = splitStr.join(' ');
    } else if (corr == 'percent') {
      if (parseFloat(value) < 1) {
        retVal =
          value +
          '%<td></tr><tr><td class="left-float"><b>Probability:</b></td><td class="right-float">Lower probability radon area';
      } else if (parseFloat(value) < 10) {
        retVal =
          value +
          '%<td></tr><tr><td class="left-float"><b>Probability:</b></td><td class="right-float">Intermediate probability radon area';
      } else {
        retVal =
          value +
          '%<td></tr><tr><td class="left-float"><b>Probability:</b></td><td class="right-float">Higher probability radon area';
      }
      retVal +=
        '</td><tr><tr><td class="left-float"><b>Link:</b></td><td class="right-float"><a target="_blank" href="http://www.ukradon.org/radonmaps/">UK Radon Map</a>';
    } else if (corr == 'add20') {
      var len = value.length - 2;
      retVal = value.substring(0, len) + '20' + value.substring(len);
    } else if (corr == 'chopdate') {
      if (parseInt(value).toString() == value.toString()) {
        retVal = value.substr(6, 2) + '-' + value.substr(4, 2) + '-' + value.substr(0, 4);
      } else if (value.indexOf('/') !== -1) {
        retVal = value.replace(/\//g, '-').substr(0, 10);
        if (retVal.substr(4, 1) === '-') {
          retVal = value.substr(8, 2) + '-' + value.substr(5, 2) + '-' + value.substr(0, 4);
        }
      } else if (value.split(':').length == 6) {
        t = value.split(':');
        retVal = t[2] + '-' + t[1] + '-' + t[0];
      } else {
        t = value.substring(0, 10).replace('Z', '').split('-');
        if (value) retVal = t[2] + '-' + t[1] + '-' + t[0];
        else retVal = '-';
      }
    } else if (corr == 'crowfix') {
      retVal = value.replace(' OC ', ' Open Country ').replace('RCL.', 'Registered Common Land.');
    } else if (corr == '2dpcomma') {
      retVal = parseFloat(value)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else if (corr == '2dp') {
      retVal = parseFloat(value).toFixed(2).toString();
    } else if (corr == 'currency') {
      while (/(\d+)(\d{3})/.test(value.toString())) {
        value = value.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
      }
      retVal = '£' + value;
    } else if (corr == 'standardize') {
      retVal = value.replace(/\//g, '-');
    } else if (corr == 'remove_epr') {
      retVal = value.replace('EAEPR\\EA/EPR/', '');
    } else if (corr == 'modifyurl') {
      if (this.country == 'England')
        retVal =
          "<a class='link1' href='https://historicengland.org.uk/listing/the-list/list-entry/" +
          value +
          "' target='_blank'>Historic England</a>";
      else retVal = null;
    } else if (corr == 'modifyurl2') {
      if (this.country == 'England') retVal = '';
      else retVal = "<a class='link2' href='" + value + "' target='_blank'>Cadw</a>";
    } else if (corr == 'modifyurl3') {
      retVal = "<a class='link2' href=\"" + value + "\" target='_blank'>View Application</a>";
    } else if (corr == 'modifyurl4') {
      retVal =
        "<a class='link2' href='https://historicengland.org.uk/listing/the-list/list-entry/" +
        value +
        "' target='_blank'>Historic England</a>";
    } else if (corr == 'modifyurl5') {
      retVal = "<a class='link2' href='" + value + "' target='_blank'>Landscapes for Life</a>";
    } else if (corr == 'modifyurl6') {
      retVal =
        "<a class='link2' href='https://designatedsites.naturalengland.org.uk/SiteDetail.aspx?SiteCode=S" +
        value +
        "' target='_blank'>Natural England</a>";
    } else if (corr == 'addmeter') {
      retVal = parseFloat(value).toFixed(2).toString() + 'm';
    } else if (corr == 'modifyurl7') {
      retVal = "<a class='link2' href='" + value + "' target='_blank'>More Information</a>";
    } else if (corr == 'modifyurlez') {
      retVal =
        "<a class='link2' href='https://enterprisezones.communities.gov.uk/enterprise-zone-finder/' target='_blank'>More Information</a>";
    } else if (corr == 'modifyarticle4') {
      if (value.includes('cityoflondon'))
        value =
          'https://www.cityoflondon.gov.uk/assets/Services-Environment/planning-other-policy-document-article4-confirmation-notice-final.pdf';
      retVal = "<a class='link2' href='" + value + "' target='_blank'>More Information</a>";
    } else if (corr == 'usrn') {
      retVal = value.replace('usrn', 'USRN');
    } else if (corr == 'truefalse') {
      retVal = value === 'T' ? 'True' : 'False';
    } else if (corr == 'replaceUnderscore') {
      retVal = value.replace(/_/g, ' ');
    } else if (corr == 'stockport_cons') {
      retVal =
        "<a class='link2' href='https://www.stockport.gov.uk/find-conservation-and-heritage-assets' target='_blank'>More Information</a>";
    }
  }
  if (typeof this.dictionary[retVal] !== 'undefined') retVal = retVal + ' : ' + this.dictionary[retVal];
  return retVal;
};
Utils.prototype.checkAbsBottom = function (key) {
  return this.toabsbottom.indexOf(key) > -1;
};
Utils.prototype.checkBottom = function (key) {
  return this.tobottom.indexOf(key) > -1;
};
Utils.prototype.checkTop = function (key) {
  return this.totop.indexOf(key) > -1;
};
Utils.prototype.str_tidy = function (val) {
  if (typeof val !== 'undefined' && val) {
    if (!$.isArray(val)) {
      val = val.toString().replace('00:00:00', '');
      val = val.toString().replace('00:00', '');
    }
  }
  return val;
};
Utils.prototype.spelling = val => {
  if (val && typeof val === 'string') {
    corrections.forEach(c => {
      val = val.replace(c.from, c.to);
    });
  }
  return val;
};
Utils.prototype.populateCountry = function (source) {
  if (source == 'Cadw' || source == 'WAL/BBNP/1') this.country = 'Wales';
  else this.country = 'England';
};
Utils.prototype.pad = function (num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};
Utils.prototype.PROWParams = {
  bs: { x: 'StartEasting', y: 'StartNorthing' },
  cf: { x: 'starteasting', y: 'startnorthing' },
  ch: { x: 'e', y: 'n' },
  nn: { x: 'x', y: 'y' },
  ts: { x: 'easting', y: 'northing' },
  vg: { x: 'StartEasting', y: 'StartNorthing' },
  we: { x: 'x', y: 'y' },
};
Utils.prototype.GetDescription = function (cat) {
  let sub = '';
  if (cat) sub = cat.substr(0, 2).toLowerCase();
  switch (sub) {
    case 're':
      return 'Created from Land Registry Cadastral parcels whose proprietor is Highways England or a predecessor.  Land Registry data taken in July 2017.';
    case 'ca':
      return 'Created from Highways England’s Pavement Management System’s (HAPMS) GPS data of lane 1 of the network.  Land is not registered under Highways England’s name.  For example, but not limited to, unregistered ‘ancient’ highway vested in Highways England, or bridge carrying highways over a rail line.  Features in category are replaced by ‘Highways England data’ once audited by the company.';
    case 'hi':
      return 'Created by Highways England, digitised land parcels relating to highway land that is not registered, not yet registered or un-registerable.  Features in this category replace ‘Carriageway – General Boundary’ features over time.';
    default:
      return '-';
  }
};
Utils.prototype.WMSlayers = {
  HS2: 'hs2',
  aonb_eng_wales_2018: 'aonb',
  aonb_eng_wales: 'aonb',
  aonb: 'aonb',
  Underground: 'underground',
  docklands_light_railway: 'dlr',
  dlr_route: 'dlr',
  welsh_public_land_combined: 'welsh_public_land_combined',
  listed_buildings_032020: 'listed_buildings',
  listed_buildings: 'listed_buildings',
  listed_buildings_11_2016: 'listed_buildings',
  ne_crow_access_layer: 'ne_crow_access_layer',
  Coastal_Paths_Eng_Wales: { england: 'england_coastal_path', wales: 'wales_coastal_path' },
  ea_historic_landfill_sites: 'historic_landfill_sites',
  ea_authorised_landfill_sites: 'permitted_waste',
  ne_crow_section_15_land: 'ne_crow_section_15_land',
  mail_rail: 'mailrail',
  he_parksandgardens_26_01_2018: 'he_parksandgardens',
  he_parksandgardens: 'he_parksandgardens',
  he_scheduledmonuments_26_01_2018: 'he_scheduled_monuments',
  he_scheduled_monuments_032020: 'he_scheduled_monuments',
  he_scheduled_monuments: 'he_scheduled_monuments',
  he_parksandgardens_17032020: 'he_parksandgardens',
  crossrail: 'crossrail',
  england_highways: 'england_highways',
  crossrail_2_2015: 'crossrail',
  sssi_england_and_wales: 'sssi',
  greenbelt_2016_17: 'green_belt',
  greenbelt_2018_19: 'green_belt',
  greenbelt: 'green_belt',
  conservation_areas_2017_new: 'conservation',
  conservation_areas: 'conservation',
  planning_authorities: 'planning_authorities',
  sa_thames_tideway_tunnel: 'thames_tideway_tunnel',
  cheshire_brine_subsidence_compensation: 'cheshire_brine_area',
  chesire_brine_area: 'chesbrine',
  surface_water_flooding_wales: 'vw_ufmfsw',
  sac_england_wales: { england: 'special_areas_of_conservation_england', wales: 'special_areas_of_conservation_wales' },
  spa_england_wales: { england: 'special_protection_areas_england', wales: 'special_protection_areas_wales' },
  local_nature_reserve: { england: 'local_nature_reserves_england', wales: 'local_nature_reserves_wales' },
  national_nature_reserve: { england: 'national_nature_reserves_england', wales: 'national_nature_reserves_wales' },
  designated_protected_areas: 'designated_protected_areas',
  'Enterprise Zones England': 'enterprise_zones',
};
Utils.prototype.getPrice = function (titles) {
  let price = 0;
  if (titles <= 30) price = 40;
  else if (titles < 200) price = 40 + Math.ceil((titles - 30) / 10) * 5;
  else price = 130;
  return price;
};
